import { observable, action } from "mobx"

class DialogInfo {
  // btnState：0错误提示（取消）、1已领过（立即使用）、2成功（立即使用+取消）
  @observable
  info = {
    isShow: false,
    msg: '',
    toUseUrl: '',
    btnState: 0
  }

  @action.bound
  show(msg,toUseUrl,btnState) {
    this.info = {
      isShow: true,
      msg,
      toUseUrl,
      btnState
    }
  }

  @action.bound
  hide() {
    this.info.isShow = false
  }
}

export default new DialogInfo()


// WEBPACK FOOTER //
// ./src/stores/DialogInfo.js